
import * as _ from 'lodash';
import React, { useEffect } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useValidation } from '../../../../../../../../../hooks/use-validation';
import { getCountries } from '../../../../../../../../../helpr/genericFormData';
import { getCurrency } from '../../../../../../../../../helpr/listingFormData';
import { multiSecurityInfoObj, multiSecurityInfoValidator, multiSecurityInfoValidatorPublished } from '../../../../../../../../../form-control/listing-form/security-info-control';
import { TextInput, CurrencyInput, DropDown, InputGroup, NumericInput, DateInput } from '../../../../../../../../../components/form/form';
import { getCouponTypes } from '../../../../../../../../../helpr/listingFormData';

import CouponInfo from '../coupon-info/coupon-info';
import CouponFrequency from '../coupon-frequency/coupon-frequency';
import SecurityInfo from '../../../../../../../../../models/securityInfo';
import OptionalRedemptionDates from '../optional-redemption-dates/optional-redemption-dates';
import { PATTERN_TENOR } from '../../../../../../../../../helpr/constants';

import styles from './security-information.module.scss'


const SecurityForm = ({index, securityInfo, saveSecurityInfo, deleteSecurity, securityListBuffer, isPublished}) => {
  const validatorObj = isPublished? multiSecurityInfoValidatorPublished:multiSecurityInfoValidator;
  console.log(validatorObj);
  const securityFormState = useValidation(validatorObj, multiSecurityInfoObj(_.cloneDeep(securityInfo)), {border: '1px solid red'});
  const { getTextFieldProps, getDropdownProps, getField, validate, forceSetField, forceSetFieldDynamic } = securityFormState;

  /*
    Build date for caldendar constraints Advance date by 1 day (forward date)
    and remove constraint if termsheet is already published.
  */
  const today = new Date();
  today.setDate(today.getDate() + 1);
  const dateToday = isPublished? null: [
    today.getFullYear(),
    ('0'+ parseInt(today.getMonth() +1).toString()).slice(-2),('0'+today.getDate()).slice(-2)
  ].join('-');

  useEffect(()=>{
    forceSetField('id', securityInfo['id']);
    forceSetField('longName', securityInfo['longName']);
    forceSetField('prefShortName', securityInfo['prefShortName']);
    forceSetField('countryOfIssue', securityInfo['countryOfIssue']);
    forceSetField('currency', securityInfo['currency']);
    forceSetField('listingDate', securityInfo['listingDate']);
    forceSetField('maturityDate', securityInfo['maturityDate']);
    forceSetField('amount', securityInfo['amount'].toString());
    forceSetField('amountOutstanding', securityInfo['amountOutstanding'].toString());
    forceSetField('tenor', securityInfo['tenor']);
    forceSetField('issuePrice', securityInfo['issuePrice'].toString());
    forceSetField('redemptionPrice', securityInfo['redemptionPrice'].toString());
    forceSetField('couponType', securityInfo['couponType']);
    forceSetField('couponDiscountRate', securityInfo['couponDiscountRate'].toString());
    forceSetField('couponFixedInterestRate', securityInfo['couponFixedInterestRate'].toString());
    forceSetField('couponFixedRateSettingDate', securityInfo['couponFixedRateSettingDate']);
    forceSetField('couponFixedRefRateUsed', securityInfo['couponFixedRefRateUsed'].toString());
    forceSetField('couponFixedSpreadOverRefRate', securityInfo['couponFixedSpreadOverRefRate'].toString());
    forceSetField('couponFloatingRateBasis', securityInfo['couponFloatingRateBasis'].toString());
    forceSetField('couponSteppedProvisionDesc', securityInfo['couponSteppedProvisionDesc']);
    forceSetField('couponPaymentDate', securityInfo['couponPaymentDate']);
    forceSetField('couponFirstPaymentDate', securityInfo['couponFirstPaymentDate']);
    forceSetField('couponRecordDate', securityInfo['couponRecordDate']);
    forceSetField('couponClosedPeriod', securityInfo['couponClosedPeriod']);
    forceSetField('couponFrequency', securityInfo['couponFrequency']);
    forceSetField('primaryMarketMinDenomination', securityInfo['denomination']['primary']['minimum'].toString());
    forceSetField('primaryMarketMinIncrements', securityInfo['denomination']['primary']['increments'].toString());
    forceSetField('secondaryMarketMinDenomination', securityInfo['denomination']['secondary']['minimum'].toString());
    forceSetField('secondaryMarketMinIncrements', securityInfo['denomination']['secondary']['increments'].toString());
    forceSetFieldDynamic('redemptionDetail', securityInfo['redemptionDetail']);
  },[securityListBuffer])
  const save = (index) => {
    console.log(securityInfo)
    const { isFormValid, formState } = validate();
    if( isFormValid ) {
      saveSecurityInfo(index, new SecurityInfo({...formState, denomination: {
        primary: {
          minimum: formState.primaryMarketMinDenomination,
          increments: formState.primaryMarketMinIncrements
        },
        secondary: {
          minimum: formState.secondaryMarketMinDenomination,
          increments: formState.secondaryMarketMinIncrements
        },
      }, isDeletable: securityInfo['isDeletable']}));
    }
  }

  return (
    <>
      <Row className="mb-5">
        <Col>
          <InputGroup header="SECURITY NAME">
            <Row className="mt-2">
              <Col sm={6} lg={6}>
                <TextInput inputProps={getTextFieldProps('longName')} maxLength="150">
                  Long Name:*
                </TextInput>
                <TextInput inputProps={getTextFieldProps('prefShortName')} maxLength="75">
                  Preferred Short Name:*
                </TextInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="ISSUE DETAILS" style={{paddingTop: '0px'}}>
            <Row className="mt-2">
              <Col sm={6} lg={3}>
                <DropDown inputProps={getDropdownProps('countryOfIssue')} values={getCountries()}>
                  Country of Issue:*
                </DropDown>
              </Col>
              <Col sm={6} lg={3}>
                <DropDown inputProps={getDropdownProps('currency')} values={getCurrency()}>
                  Issue Currency:*
                </DropDown>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('listingDate')} min={dateToday}>
                  Issue/Listing Date:*
                </DateInput>
              </Col>
              <Col sm={6} lg={3}>
                <DateInput inputProps={getTextFieldProps('maturityDate')} min={getField('listingDate')}>
                  Maturity Date:*
                </DateInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <CurrencyInput inputProps={getTextFieldProps('amount')} placeholder="0" noDecimal>
                  Issue / Reopening Amount:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={3}>
                <CurrencyInput inputProps={getTextFieldProps('amountOutstanding')} placeholder="0" noDecimal>
                  Total Amount Outstanding (for Reopening):
                </CurrencyInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <TextInput inputProps={getTextFieldProps('tenor')} maxLength="50" pattern={PATTERN_TENOR}>
                  Tenor:*
                </TextInput>
              </Col>
              <Col sm={6} lg={3}>
                <NumericInput inputProps={getTextFieldProps('issuePrice')} decimalLimit={4} numberLimit={1000} variant="default">
                  Issue Price (%):*
                </NumericInput>
              </Col>
            </Row>
            <Row className="mt-1">
              <Col sm={6} lg={3}>
                <NumericInput inputProps={getTextFieldProps('redemptionPrice')} decimalLimit={4} numberLimit={1000} variant="default">
                  Redemption Price (%):*
                </NumericInput>
              </Col>
            </Row>
            <OptionalRedemptionDates securityFormState={securityFormState} isPublished={isPublished}/>
          </InputGroup>
          <InputGroup header="PRIMARY MARKET" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('primaryMarketMinDenomination')} placeholder="0" maxLength="50" noDecimal>
                  Minimum Denomination:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('primaryMarketMinIncrements')} placeholder="0" maxLength="50" noDecimal>
                  Minimum Increments:*
                </CurrencyInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="SECONDARY MARKET" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('secondaryMarketMinDenomination')} placeholder="0" maxLength>
                  Minimum Denomination:*
                </CurrencyInput>
              </Col>
              <Col sm={6} lg={4}>
                <CurrencyInput inputProps={getTextFieldProps('secondaryMarketMinIncrements')} placeholder="0">
                  Minimum Increments:*
                </CurrencyInput>
              </Col>
            </Row>
          </InputGroup>
          <InputGroup header="COUPON TYPE:*" style={{paddingTop: '0px'}}>
            <Row className="mt-1">
              <Col sm={6} lg={4}>
                <DropDown inputProps={getDropdownProps('couponType')} values={getCouponTypes()}/>
              </Col>
            </Row>
            <CouponInfo securityFormState={securityFormState}/>
          </InputGroup>
          <InputGroup header="COUPON FREQUENCY:*" style={{paddingTop: '0px'}}>
            <CouponFrequency index={index} securityFormState={securityFormState}/>
            <Row className="mt-5">
              <Col>
                <div className={styles['btn-actions']}>
                  <Button disabled={securityInfo['isDeletable'] === false} onClick={()=>deleteSecurity(index)}>DELETE</Button>
                  <Button onClick={()=>save(index)} className="btn-secondary">SAVE</Button>
                </div>
              </Col>
            </Row>
          </InputGroup>
        </Col>
      </Row>
    </>
  )

}

export default SecurityForm;




